export default __webpack_public_path__ + "../staticImages/review-medals.svg";